import { useRef } from 'react';
import { NBN_SESSION_KEYS } from '@belong/constants';
import { clearKeyFromSessionStorage } from '@belong/session-storage';
import { IDynamicPageProps, IServerSideProps } from 'src/core/types';
import { getNbnPlanSummaryServerSideProps } from 'src/helpers/nextjs/getNbnPlanSummaryServerSideProps';
import { withServerSideAppProps } from 'src/helpers/nextjs/withServerSideAppProps';
import DynamicPage from '../../[[...slug]]';

export default function CampaignPage(props: IServerSideProps<IDynamicPageProps>) {
  // Clear NBN session state during this render, before child sections read it,
  // so each campaign visit starts pre-SQ (no nbnProductModel). Effect-based
  // cleanup runs too late: child effects fire before the parent's.
  const clearedRef = useRef(false);
  if (!clearedRef.current) {
    clearedRef.current = true;
    Object.values(NBN_SESSION_KEYS).forEach(key => clearKeyFromSessionStorage(key));
  }

  return <DynamicPage {...props} />;
}

export const getServerSideProps = withServerSideAppProps<IDynamicPageProps>(getNbnPlanSummaryServerSideProps);
